import { app } from '@store/modules/app';
import axios from 'axios';
import { getNewAccessToken } from '@src/api/login';
import router from '@router/index';

let isRefreshing = false;
let subscribers: Array<(args: string) => void> = [];

function addSubscriber(cb: (args: string) => void): void {
	subscribers.push(cb);
}

function onAccessTokenFetched(token: string): void {
	subscribers = subscribers.filter((callback) => callback(token));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function oAuthTokenRefresh(err: any): Promise<unknown> {
	const {
		config,
		response: { status }
	} = err;
	const originalRequest = config;
	const minTokenScopeRequiredOnCurrentRoute = router.currentRoute.meta?.minTokenScopeRequired;

	if (status === 401) {
		if (minTokenScopeRequiredOnCurrentRoute === 'PRIVILEGED_ACCESS') {
			router.go(0); // re-run global route logic for PRIVILEGED_ACCESS since you can't refresh it
		}

		if (!isRefreshing) {
			isRefreshing = true;
			getNewAccessToken()
				.then((refreshToken) => {
					app.setUserAuthData(refreshToken);
					isRefreshing = false;
					onAccessTokenFetched(refreshToken.access_token);
				})
				.catch(() => (window.location.href = `${process.env.VUE_APP_BASE_PATH}/logout-success`));
		}

		const retryInitialRequest = new Promise((resolve) => {
			addSubscriber((token: string) => {
				originalRequest.headers.authorization = `Bearer ${token}`;
				resolve(axios(originalRequest));
			});
		});

		return retryInitialRequest;
	}
	return Promise.reject(err);
}
